import _ from 'lodash';
import React from 'react';

export const getSortedMenu = ({ navigation, drawerId }) => {
  const allMenusArray = navigation.filter(({ NavigateURL }) => !NavigateURL);

  const menuOrder = [
    drawerId === 'ModuleAdminMenu' ? 'ModuleAdminMenu' : 'SystemSetupMenu',
    drawerId === 'ModuleAdminMenu' ? 'SystemSetupMenu' : 'ModuleAdminMenu',
    'Create',
    'Find',
    'Favorites',
    'Recent',
    'AdminMenu',
  ];

  const getMenuPosition = (item) =>
    menuOrder.findIndex(
      (weightedItem) => item.toLowerCase().indexOf(weightedItem.toLowerCase()) > -1
    );

  return allMenusArray.sort((a, b) => getMenuPosition(b.Id) - getMenuPosition(a.Id)).reverse();
};

const regExpEscape = (literal_string) =>
  // eslint-disable-next-line no-useless-escape
  literal_string.replace(/[-[\]{}()*+!<=:?.\/\\^$|#\s,]/g, '\\$&');

export const getHighlightedText = (text, highlight, highlightClassName) =>
  text.split(new RegExp(`(${regExpEscape(highlight)})`, 'gi')).map((part, i) => (
    <span
      key={i}
      className={part.toLowerCase() === highlight.toLowerCase() ? highlightClassName : ''}
    >
      {part}
    </span>
  ));

export const getSearchResultObject = ({
  sortedMenuElements,
  searchText,
  recentEvents,
  favorites,
}) => {
  const searchedElements = sortedMenuElements.map((item) =>
    !_.isNil(item.contentInfos.menu.contentData)
      ? {
          ...item.contentInfos.menu.contentData,
          templateData: item.contentInfos.menu.contentData?.templateData
            .map((templateDataItem) => ({
              ...templateDataItem,
              Links: templateDataItem.Links.filter(({ Text }) =>
                Text.toLowerCase().includes(searchText.toLowerCase())
              ),
            }))
            .filter(({ Links }) => Links.length),
        }
      : {
          Title: item.Id,
          templateData:
            item.Id === 'Recent'
              ? recentEvents
                  .map((recentEvent) => ({
                    Text: item.Id,
                    events: recentEvent.events.filter((event) =>
                      event.EntityKey.toLowerCase().includes(searchText.toLowerCase())
                    ),
                  }))
                  .filter((recentEvent) => recentEvent.events.length)
              : [
                  {
                    Text: item.Id,
                    favorites: favorites.filter((favorite) =>
                      favorite.EntityKey.toLowerCase().includes(searchText.toLowerCase())
                    ),
                  },
                ].filter((favoriteData) => favoriteData.favorites.length),
        }
  );

  const searchedElementsLength = searchedElements.reduce(
    (acc, searchItem) => acc + searchItem.templateData.length,
    0
  );

  return { searchedElements, searchedElementsLength };
};
